export const TRACKED = "Tracked";

export const devices = {
  mobile: `(min-width: 375px)`,
  mobileL: `(min-width: 576px)`,
  tablet: `(min-width: 768px)`,
  tabletL: `(min-width: 992px)`,
  desktop: `(min-width: 1200px)`,
  desktopL: `(min-width: 1440px)`,
}